import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { LoginService } from 'src/app/services/login-service/login.service';
import { environment } from 'src/environments/environment';

import { LOGIN_PAGES } from '../enum-login-pages';

@Component({
  selector: 'app-forgot-password-email',
  templateUrl: './forgot-password-email.component.html',
  styleUrls: ['./forgot-password-email.component.scss'],
})
export class ForgotPasswordEmailComponent implements OnInit {
  @Output() nextStep = new EventEmitter<number>();
  @Output() forgotPasswordEmail = new EventEmitter<string>();

  loading = false;

  frmForgotPassword = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '[a-zA-Z0-9._-]{3,}@[a-zA-Z0-9.-]{3,}[.][a-zA-Z]{2,4}'
      ),
    ]),
  });

  constructor(private loginService: LoginService) {}

  ngOnInit(): void {}

  checkEmail() {
    this.loading = true;

    const userPool = this.loginService.getCognitoUserPool();
    const cognitoUser = new CognitoUser({
      Username: this.frmForgotPassword.value.email.toLowerCase(),
      Pool: userPool,
    });

    cognitoUser.forgotPassword({
      onSuccess: (res) => {
        this.loading = false;
      },
      onFailure: (err) => {
        this.loading = false;
      },
      inputVerificationCode: (res) => {
        this.verificationCode();
      },
    });
  }

  back() {
    this.nextStep.emit(LOGIN_PAGES.PASSWORD);
  }

  verificationCode() {
    this.nextStep.emit(LOGIN_PAGES.CHANGE_PASSWORD);
    this.forgotPasswordEmail.emit(
      this.frmForgotPassword.value.email.toLowerCase()
    );
    this.loading = false;
  }
}
